export default function Footer() {
  return (
    <footer className="bg-dark-charcoal border-t border-tropical-teal">
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-white text-base">
            Central Pool and Spa
          </div>
          <a
            href="tel:+17862738796"
            className="text-white hover:text-tropical-teal transition-colors flex items-center gap-2 cursor-pointer"
          >
            <i className="ri-phone-line"></i>
            +1 (786) 273-8796
          </a>
          <a
            href="mailto:migueljralanso@gmail.com"
            className="text-gray-300 hover:text-tropical-teal transition-colors flex items-center gap-2 cursor-pointer"
          >
            <i className="ri-mail-line"></i>
            migueljralanso@gmail.com
          </a>
        </div>
        <div className="mt-6 text-center">
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-gray hover:text-tropical-teal transition-colors text-sm"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}